(function () {
  var cfgEl = document.getElementById('ec-ab-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }
  if (!cfg.test) return;

  var variant = cfg.variant === 'B' ? 'B' : 'A';

  var tag = cfg.test + '-' + variant;
  var LS_KEY = 'ec_ab_stamped';
  window.__ecAb = tag;

  function stamped() {
    try { return sessionStorage.getItem(LS_KEY) === tag; } catch (err) { return false; }
  }
  function markStamped() {
    try { sessionStorage.setItem(LS_KEY, tag); } catch (err) {}
  }

  var inFlight = false;
  function stamp() {
    if (inFlight || stamped()) return;
    inFlight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _ab: tag } })
    }).then(function (res) {
      if (res.ok) markStamped();
    }).catch(function () {}).finally(function () { inFlight = false; });
  }

  document.addEventListener('cart:item-added', stamp);
  document.addEventListener('cart:updated', stamp);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stamp);
  } else {
    stamp();
  }

  var tries = 0;
  (function tagClarity() {
    if (window.clarity) {
      window.clarity('set', 'ab_test', tag);
    } else if (tries++ < 60) {
      setTimeout(tagClarity, 500);
    }
  })();
})();
